/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { OpenBalanceDetailResponse } from './OpenBalanceDetailResponse';
import {
    OpenBalanceDetailResponseFromJSON,
    OpenBalanceDetailResponseFromJSONTyped,
    OpenBalanceDetailResponseToJSON,
    OpenBalanceDetailResponseToJSONTyped,
} from './OpenBalanceDetailResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface OpenBalanceResponse
 */
export interface OpenBalanceResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof OpenBalanceResponse
     */
    tenantId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof OpenBalanceResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    userEmail: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    addressLine3: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    state: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    zip: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    cellPhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    homePhone: string | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof OpenBalanceResponse
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    studentName: string;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    currency: string;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof OpenBalanceResponse
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    locationName: string | null;
    /**
     * 
     * @type {number}
     * @memberof OpenBalanceResponse
     */
    totalAmount: number;
    /**
     * 
     * @type {boolean}
     * @memberof OpenBalanceResponse
     */
    userHasValidVault: boolean;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof OpenBalanceResponse
     */
    userVaultId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    externalTerminalId: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    externalAchTerminalId: string | null;
    /**
     * 
     * @type {Array<OpenBalanceDetailResponse>}
     * @memberof OpenBalanceResponse
     */
    details: Array<OpenBalanceDetailResponse>;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceResponse
     */
    userVaultType: string | null;
}

/**
 * Check if a given object implements the OpenBalanceResponse interface.
 */
export function instanceOfOpenBalanceResponse(value: object): value is OpenBalanceResponse {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('userEmail' in value) || value['userEmail'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    if (!('homePhone' in value) || value['homePhone'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('userHasValidVault' in value) || value['userHasValidVault'] === undefined) return false;
    if (!('userVaultId' in value) || value['userVaultId'] === undefined) return false;
    if (!('externalTerminalId' in value) || value['externalTerminalId'] === undefined) return false;
    if (!('externalAchTerminalId' in value) || value['externalAchTerminalId'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('userVaultType' in value) || value['userVaultType'] === undefined) return false;
    return true;
}

export function OpenBalanceResponseFromJSON(json: any): OpenBalanceResponse {
    return OpenBalanceResponseFromJSONTyped(json, false);
}

export function OpenBalanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenBalanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': ApiUserTasksGetPageParameterFromJSON(json['tenantId']),
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'userName': json['userName'],
        'userEmail': json['userEmail'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'country': json['country'],
        'cellPhone': json['cellPhone'],
        'homePhone': json['homePhone'],
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'studentName': json['studentName'],
        'currency': json['currency'],
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'locationName': json['locationName'],
        'totalAmount': json['totalAmount'],
        'userHasValidVault': json['userHasValidVault'],
        'userVaultId': ActorActivityRecordActorUserIdFromJSON(json['userVaultId']),
        'externalTerminalId': json['externalTerminalId'],
        'externalAchTerminalId': json['externalAchTerminalId'],
        'details': ((json['details'] as Array<any>).map(OpenBalanceDetailResponseFromJSON)),
        'userVaultType': json['userVaultType'],
    };
}

export function OpenBalanceResponseToJSON(json: any): OpenBalanceResponse {
    return OpenBalanceResponseToJSONTyped(json, false);
}

export function OpenBalanceResponseToJSONTyped(value?: OpenBalanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': ApiUserTasksGetPageParameterToJSON(value['tenantId']),
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'userName': value['userName'],
        'userEmail': value['userEmail'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'country': value['country'],
        'cellPhone': value['cellPhone'],
        'homePhone': value['homePhone'],
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'studentName': value['studentName'],
        'currency': value['currency'],
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'locationName': value['locationName'],
        'totalAmount': value['totalAmount'],
        'userHasValidVault': value['userHasValidVault'],
        'userVaultId': ActorActivityRecordActorUserIdToJSON(value['userVaultId']),
        'externalTerminalId': value['externalTerminalId'],
        'externalAchTerminalId': value['externalAchTerminalId'],
        'details': ((value['details'] as Array<any>).map(OpenBalanceDetailResponseToJSON)),
        'userVaultType': value['userVaultType'],
    };
}

